import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// NewUser page components
import NumberFormat from "react-number-format";
import { useEffect, useState } from "react";
import MDButton from "components/MDButton";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { URL_API } from "config";
import { toast } from "react-toastify";
import { Box, LinearProgress } from "@mui/material";
import { useAuthContext } from "context/AuthContext";

export default function CooperatedComplementsSixth() {
  const [income, setIncome] = useState();

  const [loading, setLoading] = useState(false);
  const { uuid } = useParams();
  const { user } = useAuthContext();

  let tag = localStorage.getItem("Tag");

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        if (uuid) {
          setLoading(true)

          const response = await axios.get(`${URL_API}/cooperated/${uuid}`, {
            headers: {
              Authorization: `Bearer ${tag}`,
            },
          });

          setIncome(response.data.income);

          setLoading(false);
        }
      } catch (e) {
        toast.error(e.response.data)
      }
    })()
    // eslint-disable-next-line
  }, [uuid])

  const handleNext = async () => {
    try {
      if (user.profile !== 99) {
        if (!income) return toast.warn("Preecha o campo obrigatório");

        if (uuid) {
          const response = await axios.put(`${URL_API}/cooperated/${uuid}`, { income, step: 6 }, {
            headers: {
              Authorization: `Bearer ${tag}`,
            },
          });

          if (response.status === 200) navigate(`/admin/colaboradores/atualizar/${uuid}?step=7`);
        } else {
          const response = await axios.post(`${URL_API}/cooperated`, { income }, {
            headers: {
              Authorization: `Bearer ${tag}`,
            },
          });

          if (response.status === 200) navigate(`/admin/colaboradores/atualizar/${response.data.uuid}?step=7`);
        }
      } else {
        navigate(`/admin/colaboradores/atualizar/${uuid}?step=6`);
      }
    } catch (e) {
      toast.error(e.response.data)
    }
  }

  return (
    <MDBox>
      <MDBox lineHeight={0}>
        <MDTypography variant="h5">Renda</MDTypography>
        <MDTypography variant="button" color="text">
          Informação obrigatória *
        </MDTypography>
      </MDBox>

      {
        loading ?
          <Box sx={{ width: '100%' }}>
            <LinearProgress sx={{ overflow: 'hidden' }} />
          </Box> :
          <>
            <MDBox mt={1.625}>
              <div
                style={{
                  fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
                  fontWeight: "400",
                  lineHeight: "1.4375em",
                  letterSpacing: "0.00938em",
                  boxSizing: "border-box",
                  cursor: "text",
                  display: "inline-flex",
                  WebkitBoxAlign: "center",
                  alignItems: "center",
                  width: "100%",
                  position: "relative",
                  fontSize: "0.875rem",
                  color: "#344767",
                }}
              >
                <NumberFormat
                  label="Renda"
                  style={{
                    font: "inherit",
                    letterSpacing: "inherit",
                    color: "currentColor",
                    padding: "4px 0 5px",
                    border: "0",
                    boxSizing: "content-box",
                    background: "none",
                    height: "1.4375em",
                    margin: "0",
                    WebkitTapHighlightColor: "transparent",
                    display: "block",
                    minWidth: "0",
                    width: "100%",
                    animationName: "mui-auto-fill-cancel",
                    animationDuration: "10ms",
                    borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
                    borderColor: "#d2d6da",
                  }}
                  prefix={"R$ "}
                  thousandSeparator="."
                  decimalSeparator=","
                  defaultValue="0,00"
                  value={income}
                  onValueChange={(e) => setIncome(e.formattedValue)}
                />
              </div>
            </MDBox>

            <MDBox
              mt={2}
              width="100%"
              display="flex"
              justifyContent="space-between"
            >
              <MDButton
                variant="gradient"
                color="light"
                onClick={() => {
                  if (user?.profile !== 99) {
                    navigate(`/admin/colaboradores/atualizar/${uuid}?step=5`)
                  } else {
                    navigate(`/admin/colaboradores/atualizar/${uuid}?step=4`)
                  }
                }}
              >
                voltar
              </MDButton>
              <MDButton
                type="submit"
                variant="gradient"
                color="dark"
                onClick={handleNext}
              >
                próximo
              </MDButton>
            </MDBox>
          </>
      }
    </MDBox>
  );
}

// typechecking props for CooperatedComplementsSixth
CooperatedComplementsSixth.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};
